export default "__VITE_ASSET__$bvwsNaq__"